import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Link from "components/link";
import IconButton from "components/icon-button";
import { FormattedMessage } from "react-intl";
import Icon from "components/icon";
import { ConnectedPaginatedTable, TableIconCell, CustomTableRow } from "components/table";
import query from "./query";
import PropTypes from "prop-types";
import { HeaderCell } from "components/table";
import { Restricted, permissions, useAuthDataContext } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import mutation from "./mutation";
import { useMutation } from "@apollo/react-hooks";
import { useCurrentCustomerContext } from "components/current-customer-context";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";
import { EmailDisplay, PhoneDisplay } from "components/display-data";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="app.page.user" />
    </HeaderCell>
    <HeaderCell>
      <FormattedMessage id="user.roles" />
    </HeaderCell>
    <TableIconCell />
  </TableRow>
);

const RowComponent = ({ classes, item, refetchData }) => {
  const detailsUrl = `/user/details/${item.username}`;
  const [deleteUser] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  return (
    <CustomTableRow key={item.username} href={detailsUrl}>
      <TableCell>
        <div className={classes.title}>{item.username}</div>
        <div>{item.name}</div>
        <div onClick={e => e.stopPropagation()}>
          <EmailDisplay email={item.email} />
        </div>
        <div>
          <PhoneDisplay phone={item.telephone} />
        </div>
      </TableCell>
      <TableCell>
        {item.roles.map(role => (
          <p key={role.id}>{role.name}</p>
        ))}
      </TableCell>
      <TableIconCell>
        <Link href={detailsUrl} target="_blank" rel="noopener">
          <IconButton>
            <Icon name="launch" />
          </IconButton>
        </Link>
        <Restricted permissions={[permissions.user_manage]}>
          <Link href={`/user/edit/${item.username}`}>
            <IconButton>
              <Icon name="edit" />
            </IconButton>
          </Link>
          <DeleteActionWithModal
            mutation={deleteUser}
            mutationVariables={{
              username: item.username,
              customerId: currentCustomerId,
            }}
            elementNameInResult="deleteUser"
            elementToDelete={item.username}
            refetchDataOnSuccess
            refetchData={refetchData}
          />
        </Restricted>
      </TableIconCell>
    </CustomTableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   * Función de refetch de datos
   */
  refetchData: PropTypes.func.isRequired,
};

const StyledRowComponent = withStyles(styles)(RowComponent);

const UserPaginatedTable = props => {
  const { hasAdminPrivileges, manageableUserRoles } = useAuthDataContext();
  const { contractIds } = useCurrentCustomerContext();

  return (
    <ConnectedPaginatedTable
      gqlQuery={query}
      headerComponent={Header}
      rowComponent={StyledRowComponent}
      paginatedElementsHandler={data => data.users}
      variables={{ contractIds, roles: hasAdminPrivileges ? null : manageableUserRoles }}
      {...props}
    />
  );
};

UserPaginatedTable.propTypes = {
  /**
   ** Página a cargar en la tabla
   **/
  page: PropTypes.number,
  /**
   ** Objeto que contiene los filtrados de la búsqueda
   **/
  variables: PropTypes.object,
  /**
   * Debouncea o no la recarga de la query de la tabla
   **/
  debounce: PropTypes.bool,
};

export default UserPaginatedTable;
